import { Box, Button, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { BackIcon } from "../../../../../../../components/Icons";

interface PrescriptionDrawerLayoutProps {
  closeDrawer: () => void;
  children: ReactNode;
  buttons?: ReactNode;
}

const PrescriptionDrawerLayout = ({ closeDrawer, children, buttons }: PrescriptionDrawerLayoutProps) => {
  return (
    <Box className="flex flex-col h-full w-full" sx={{ backgroundColor: "whiteWarm.main" }}>
      <Box
        className="flex items-center pt-12 pl-16 shrink-0 sticky top-0 z-10"
        sx={{ backgroundColor: "whiteWarm.main" }}
      >
        <Button variant="text" onClick={closeDrawer}>
          <BackIcon width={20} height={20} />
        </Button>
        <Typography fontSize={30} lineHeight={1} fontFamily="grenette-pro">
          Details
        </Typography>
      </Box>
      <Box
        className="flex-1 overflow-auto mt-6 ml-20 mr-10 mb-4 p-4 bg-white"
        sx={{ boxShadow: "0px 4px 6px -4px #0000001A, 0px 10px 15px -3px #0000001A" }}
      >
        {children}
      </Box>
      {buttons && (
        <Box
          className="flex sticky bottom-0 gap-2 py-6 flex-shrink-0 pl-20 pr-10
        border-t"
          sx={{ borderColor: "neutral.light", backgroundColor: "whiteWarm.main" }}
        >
          {buttons}
        </Box>
      )}
    </Box>
  );
};

export default PrescriptionDrawerLayout;
